 
export const initialState = {
 filterInfo:{
  searchText :"",
  documentType :0,
  take:10,
  skip:0
  },
  paginationCommentInfo: {
    rowsPerPage: 20,
    pageCount: 0,
    totalCount: 0,
    currentPage: 0,
  }
};
 